<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5" style="max-width: 500px">
            <div v-if="B_Loading" style="margin-top: 20px">
              <div style="width: 100px; margin: 0px auto">
                <v-img src="../../assets/equiload.gif" aspect-ratio="1"></v-img>
              </div>
              <div style="margin-top: 20px">
                <v-row v-if="T_Message != ''">
                  <v-col lg="12" class="pa-1" style="text-align: center; color: #aaa">{{ T_Message }}</v-col>
                </v-row>
              </div>
            </div>
            <v-img v-if="!B_Loading" :src="T_Logo" class="mb-4" contain height="128"></v-img>
            <v-card v-if="!B_Loading" class="elevation-12">
              <v-toolbar color="primary" dark flat style="width: 100%">
                <v-toolbar-title>{{ $COMPANY }} - Engagements</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field label="Adresse e-mail" name="login" ref="email" prepend-icon="mdi-account" type="text" v-model="T_Login" @keyup.enter.native="Fct_Connect" />
                  <v-text-field id="password" label="Mot de passe" name="password" prepend-icon="mdi-lock" type="password" v-model="T_Password" @keyup.enter.native="Fct_Connect" />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" v-on:click="Fct_Connect">Connexion</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { MixinPeriods } from "../../mixin/MixinPeriods";
import { MixinAnalyticalAccounts } from "../../mixin/MixinAnalyticalAccounts";

export default {
  mixins: [MixinPeriods, MixinAnalyticalAccounts],
  name: "App",
  props: { B_Disconnect: { type: Boolean } },
  data: () => ({
    T_Logo: "",
    T_Login: "",
    T_Password: "",
    L_UserID: 0,
    T_UserName: "",
    T_UserAdmin: "false",
    T_UserEncoder: "false",
    T_Token: "",
    B_Loaded: false,
    B_Loading: false,
    B_Approbation2Do: false,
    T_Message: "",
    B_TokenLoaded: false,
    B_UserLoaded: false,
    B_ApprobLoaded: false,
    B_PeriodsLoaded: false,
    B_AnalyticalAccountsLoaded: false
  }),
  mounted() {
    this.T_Logo = require("../../assets/" + this.$COMPANY + ".png");
    this.$refs.email.focus();
    if (this.B_Disconnect) {
      this.$root.$children[0].IsisInfo("Votre session s'est terminée", "warning");
    }
  },
  methods: {
    Fct_Loading() {
      // vérifie l'avancement du chargement de la page
      if (this.B_Loading) {
        if (!this.B_TokenLoaded) {
          this.T_Message = "Récupération du token";
        } else if (!this.B_UserLoaded) {
          this.T_Message = "Récupération de l'utilisateur";
        } else if (!this.B_ApprobLoaded) {
          this.T_Message = "Vérification des approbations";
        } else if (!this.B_PeriodsLoaded) {
          this.T_Message = "Récupération des périodes";
        } else if (!this.B_AnalyticalAccountsLoaded) {
          this.T_Message = "Récupération des comptes analytiques";
        } else {
          this.B_Loaded = true;
        }

        if (this.B_Loaded) {
          this.Fct_Launch();
        } else {
          setTimeout(this.Fct_Loading, 500);
        }
      }
    },
    Fct_Launch() {
      // redirige l'utilisateur une fois le chargement terminé
      if (!this.B_Approbation2Do) {
        this.$router.push({ name: "Engagement" });
      } else {
        this.$router.push({ name: "Approbation" });
      }
    },
    Fct_Connect() {
      this.B_Loading = true;
      this.Fct_Loading();

      var params = new URLSearchParams();
      params.append("email", this.T_Login);
      params.append("password", this.T_Password);

      this.$BackEndAPI
        .post("auth/obtain_token/", params, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
        .then(O_Response => {
          this.T_Token = O_Response.data.token; // récupération du token
          this.B_TokenLoaded = true;
          this.Fct_GetUserData();
        })
        .catch(T_Error => {
          this.B_Loading = false;
          this.Fct_Error(T_Error);
        });
    },
    Fct_Error(T_Error) {
      if (T_Error != "") {
        this.$root.$children[0].IsisInfo("Les identifiants fournis (mot de passe et/ou nom d'utilisateur) sont incorrects.", "error");
      }
    },
    Fct_GetUserData() {
      var T_Token = "JWT " + this.T_Token;
      this.$BackEndAPI
        .get("user/?email=" + this.T_Login, { headers: { Authorization: T_Token } })
        .then(O_Response => {
          if (O_Response.data != "") {
            var TO_Users = O_Response.data; // récupération de l'utilisateur
            var O_User = TO_Users[0];
            if (O_User.email == this.T_Login) {
              this.L_UserID = O_User.id;
              this.T_UserName = O_User.first_name;
              this.T_UserAdmin = O_User.is_superuser;
              this.T_UserEncoder = O_User.is_encoder;
              this.B_UserLoaded = true;
            }
          }
          if (this.B_UserLoaded) {
            this.$cookies.set("BackEndToken", this.T_Token);
            this.$cookies.set("UserID", this.L_UserID);
            this.$cookies.set("UserName", this.T_UserName);
            this.$cookies.set("UserAdmin", this.T_UserAdmin);
            this.$cookies.set("UserEncoder", this.T_UserEncoder);
            this.$cookies.set("BackEndTokenTime", Date.now());
            this.Fct_GetApprobations();
          } else {
            this.B_Loading = false;
            this.Fct_Error("Aucun enregistrement ne correspond à cet utilisateur");
          }
        })
        .catch(T_Error => {
          this.B_Loading = false;
          this.Fct_Error(T_Error);
        });
    },
    Fct_GetApprobations() {
      var self = this;
      var T_Token = "JWT " + this.T_Token;
      this.$BackEndAPI
        .get("engagements/approbnumber/", { headers: { Authorization: T_Token } })
        .then(O_Response => {
          var L_Number = 0;
          if (O_Response.data != "") {
            L_Number = parseInt(O_Response.data.count);
          }

          this.B_Approbation2Do = L_Number > 0;
          this.B_ApprobLoaded = true;

          this.Fct_PeriodsLoad().then(function() {
            var period = self.$cookies.get("Period");
            self.Fct_AnalyticalAccountsLoad(period);
          });
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
    }
  }
};
</script>
